import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateJob } from "./UpdateJobsApi";


const initialState = {
    updatedJob: {},
    isLoading: false,
    isError: false,
    error: "",
};

export const FetchEditJob = createAsyncThunk('UpdateJob/update', async({id, updatedValue}) =>{
    const updatedJob = await updateJob(id, updatedValue);
    return updatedJob;
})
    
const UpdateJobSlice = createSlice({
    name: "editJob",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(FetchEditJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(FetchEditJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.updatedJob = action.payload;
            })
            .addCase(FetchEditJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.updatedJob = {};
            })
        }
})


export default UpdateJobSlice.reducer;